import React, { Fragment, useEffect, useReducer, useState } from "react";
import Loader from "../../components/shared/Loader";
import { set, useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import cookie from "js-cookie";
import server from "../../api/server";
import { Input } from "../../components/shared/FormComponents";
import { toast } from "react-toastify";
import { v4 } from "uuid";

const ServicesShow = ({ match }) => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
		getValues,

		resetField,
	} = useForm({});

	const {
		params: { serviceCategoryID },
	} = match;

	const onStart = async () => {
		setLoading(true);
		dispatch(
			updateMeta({
				title: "تعديل التصنف",
				breadcrumb: "",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);

		await server(cookie)
			.get(`/pages/services-categories/sections/${serviceCategoryID}`)
			.then(data => {
				setValue(
					"category-title",
					data?.data?.data.section?.["category-title"]
				);
			})
			.catch(error => toast.error(error))
			.finally(() => {
				setLoading(false);
			});
	};

	const submitHandler = async data => {
		setLoading(true);
		try {
			await server(cookie).put(
				`/pages/services-categories/sections/${serviceCategoryID}`,
				{
					section: data,
				}
			);
			toast.success("تم تعديل البيانات بنجاح");
			history.push("/services/categories/index");
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	// watchers
	useEffect(() => {
		onStart();
		register("image");
	}, []);

	console.log(errors);
	return (
		<section>
			{loading && <Loader />}
			<div className="card">
				<form onSubmit={handleSubmit(submitHandler)}>
					<div className="row">
						<div className="row">
							<div className="col-md-6">
								<div className="card-body">
									<div className="form-item">
										<label htmlFor="category-title-ar">
											اسم باللغة العربية
										</label>
										<Input
											type="text"
											name="category-title.ar"
											id="category-title-ar"
											register={register}
											required={true}
										/>
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<div className="card-body">
									<div className="form-item">
										<label htmlFor="category-title-en">
											اسم بالغة الانجليزية
										</label>
										<Input
											type="text"
											name="category-title.en"
											id="category-title-en"
											register={register}
											required={true}
										/>
									</div>
								</div>
							</div>

							<div className="col-md-12">
								<div className="form-item mt-3">
									<button className="bt bt-success btn-block">ارسال</button>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</section>
	);
};
export default ServicesShow;
